export enum LabelPosition {
  LEFT,
  TOP,
  RIGHT,
}
